import * as React from 'react'
import { ErrorMessage, Field, Form, FormikProps, withFormik } from 'formik'
import * as Yup from 'yup'

import { Input } from '../elements/Input'
import styles from './styles.module.scss'
import { Textarea } from '../elements/Textarea'
import { Label } from '../elements/Label'
import { ErrorText } from '../elements/ErrorText'
import TermsOfServiceText from '../../components/TermsOfServiceText'

export interface FormValues {
  content: string
  email: string
  name: string
}

interface Props {
  initialValues: FormValues
  onSubmit: (values: FormValues) => Promise<void>
}

const validationSchema = Yup.object({
  content: Yup.string().trim().required('Required'),
  email: Yup.string().trim().email().required('Required'),
  name: Yup.string().trim().required('Required'),
})

const ObituaryMemoryCommentForm: React.FC<Props & FormikProps<FormValues>> = ({ isSubmitting }) => {
  return (
    <Form className={styles.form}>
      <div className={styles.inputsWrapper}>
        <div className={styles.messageContentWrapper}>
          <Label htmlFor="content">Message</Label>

          <Field
            as={Textarea}
            className={styles.messageContent}
            name="content"
            placeholder="Message"
          />

          <ErrorMessage component={ErrorText} name="content" />
        </div>

        <div className={styles.nameAndEmailWrapper}>
          <div>
            <Label htmlFor="name">Your Name</Label>

            <Field as={Input} name="name" required={true} />

            <ErrorMessage component={ErrorText} name="name" />
          </div>

          <div>
            <Label htmlFor="email">Email</Label>

            <Field as={Input} name="email" required={true} type="email" />

            <ErrorMessage component={ErrorText} name="email" />
          </div>
        </div>
      </div>

      <TermsOfServiceText />

      <div className={styles.bottom}>
        <button className={styles.button} disabled={isSubmitting} type="submit">
          Reply
        </button>
      </div>
    </Form>
  )
}

export default withFormik<Props, FormValues>({
  displayName: 'ObituaryMemoryCommentForm',
  handleSubmit: async (values, { props, resetForm }) => {
    await props.onSubmit(values)
    resetForm()
  },
  enableReinitialize: true,
  mapPropsToValues: (props) => props.initialValues,
  validationSchema,
})(ObituaryMemoryCommentForm)
